import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const WHATSAPP_URL = 'https://wa.me/5492236514354?text=Hola!%20Quiero%20mi%20p%C3%A1gina%20web%20en%2024%20horas';
const links = [{
  label: 'Beneficios',
  href: '#beneficios'
}, {
  label: 'Cómo funciona',
  href: '#como-funciona'
}, {
  label: 'Planes',
  href: '#planes'
}, {
  label: 'Ejemplos',
  href: '#ejemplos'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b border-black/5 bg-white/85 backdrop-blur-md" data-id="element-125" data-mp="k4wsgom4zp9">
      <nav aria-label="Principal" className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-5 sm:px-8" data-id="element-126" data-mp="ejnzgtynniu6">
        <a href="#top" className="flex items-center gap-2" data-id="element-127" data-mp="9me2mt8xs4wb">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-yellow text-sm font-extrabold text-brand-ink" data-id="element-128" data-mp="1pxi32bgacxt0">
            24
          </span>
          <span className="text-lg font-extrabold tracking-tight" data-id="element-129" data-mp="9opxjewbcr38">WEB24HS</span>
        </a>

        <ul className="hidden items-center gap-8 md:flex" data-id="element-130" data-mp="enkeebaq05kp">
          {links.map(link => <li key={link.href} data-id="element-131" data-mp="jmnl006cmjus">
              <a href={link.href} className="text-sm font-medium text-brand-ink/70 transition-colors hover:text-brand-ink" data-id="element-132" data-mp="jmdumbhe6aok">
                {link.label}
              </a>
            </li>)}
        </ul>

        <div className="hidden md:block" data-id="element-133" data-mp="3n1j9zbts5oxo">
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center rounded-full bg-brand-yellow px-5 py-2.5 text-sm font-bold text-brand-ink shadow-soft transition-transform hover:-translate-y-0.5" data-id="element-134" data-mp="3s3ie4nxcgpvo">
            Quiero mi página
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-black/10 text-brand-ink md:hidden" data-id="element-135" data-mp="39bzcakf23hv8">
          {open ? <XIcon className="h-5 w-5" data-id="element-136" data-mp="3b1mapxizs92u" /> : <MenuIcon className="h-5 w-5" data-id="element-137" data-mp="3azrsws30ox2z" />}
        </button>
      </nav>

      {open && <div className="border-t border-black/5 bg-white px-5 pb-6 pt-4 md:hidden" data-id="element-138" data-mp="363b21q4fo4m7">
          <ul className="flex flex-col gap-1" data-id="element-139" data-mp="2ibm67zseky0i">
            {links.map(link => <li key={link.href} data-id="element-140" data-mp="2dducd08771to">
                <a href={link.href} onClick={() => setOpen(false)} className="block rounded-xl px-3 py-3 text-base font-medium text-brand-ink/80 hover:bg-black/5" data-id="element-141" data-mp="2dem6e6m5crhu">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} className="mt-3 block rounded-full bg-brand-yellow px-5 py-3 text-center text-sm font-bold text-brand-ink" data-id="element-142" data-mp="7m74769tohmg">
            Quiero mi página
          </a>
        </div>}
    </header>;
}